import { render, staticRenderFns } from "./InventoryInfo.vue?vue&type=template&id=75279558"
import script from "./InventoryInfo.vue?vue&type=script&lang=js"
export * from "./InventoryInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports